import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../routes/Module2";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import Imagen from "../../images/modulo2/barrio.png";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo2/Inicio.mp3";

const Modulo1 = () => {
  const nextUnity = modulo2.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextActivity.name}`,
    linkNext: `${modulo2.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo2.title} > Inicio `,
      url: "/" + modulo2.url,
    },
  ];
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title}`,
    name: modulo2.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div>
        <h1 className="my-5">{modulo2.title}</h1>
        <AudioPlayer track={Audio} />

      </div>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <div className="row mt-4">
        <div className="col-md-8 col-sm-12">
          <p>
            En este módulo, aprenderemos sobre el lugar donde vivimos. Además,
            comprenderemos que compartimos el espacio con personas que tienen
            diferentes características y con quienes es importante aprender a
            convivir.
          </p>
        </div>
      </div>

      <div className="unit-options mb-5 mt-2 d-flex">
        <a href={"https://ciudadania.pe/actividades-interactivas/" + pages.linkNext}>
          <button className={`btn btn-${modulo2.color} me-2`}>
            Empezar actividades <FontAwesomeIcon icon={faMap} />
          </button>
        </a>
      </div>
      <GuiaDocente>
        <p>
          Lea el título de este módulo y observen la ilustración. Pregunte: ¿qué
          lugares aparecen en la imagen?, ¿quiénes aparecen allí?, ¿qué hacen?
          Enfatice que en un mismo lugar se encuentran personas con diferentes
          características. Termine leyendo el texto que aparece debajo de la
          ilustración.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Modulo1;
